var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.atmosphericHeader,style:(_vm.containerStyle)},[_c('div',{class:_vm.$style.content,style:(_vm.backgroundStyle)},[_c('img',{class:_vm.$style.image,attrs:{"src":_vm.config.backgroundImage.default}})])])}
var staticRenderFns = []

export { render, staticRenderFns }